var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6614,
    cy: 21.5981,
    r: 20.5,
    stroke: "#828282"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2855 13.4419C17.3422 13.4419 13.2855 17.4986 13.2855 22.4419C13.2855 26.6602 16.2455 30.4921 20.1761 31.4419V28.4643C19.7867 28.5496 19.4283 28.5521 19.0318 28.4352C18.4999 28.2782 18.0677 27.9239 17.7469 27.3837C17.5424 27.0387 17.18 26.6646 16.802 26.6921L16.7093 25.6415C17.5268 25.5715 18.234 26.1396 18.6539 26.8449C18.8403 27.1586 19.055 27.3425 19.3305 27.4238C19.5968 27.5022 19.8827 27.4646 20.2158 27.3469C20.2995 26.6799 20.605 26.4302 20.8359 26.0786V26.0781C18.4917 25.7285 17.5574 24.4848 17.1866 23.5032C16.6953 22.1998 16.9589 20.5715 17.8278 19.5425C17.8447 19.5224 17.8752 19.47 17.8634 19.4333C17.465 18.2299 17.9505 17.2344 17.9683 17.1288C18.4281 17.2647 18.5028 16.992 19.9655 17.8806L20.2183 18.0325C20.3241 18.0956 20.2908 18.0596 20.3966 18.0516C21.0073 17.8857 21.6511 17.7941 22.2854 17.7859C22.9245 17.7941 23.5642 17.8857 24.2002 18.0583L24.282 18.0666C24.2749 18.0655 24.3043 18.0614 24.3536 18.032C26.1807 16.9252 26.1151 17.287 26.6051 17.1277C26.6228 17.2334 27.1018 18.2451 26.7077 19.4333C26.6545 19.597 28.2917 21.0962 27.3843 23.5028C27.0135 24.4848 26.0794 25.7285 23.7352 26.0781V26.0786C24.0356 26.5366 24.3967 26.7803 24.3948 27.7251V31.4419C28.3255 30.4921 31.2854 26.6602 31.2854 22.4419C31.2855 17.4986 27.2288 13.4419 22.2855 13.4419V13.4419Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13.2855 13.4419)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.f020857c.svg";
export { ForwardRef as ReactComponent };